import script from "./KeyCap.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyCap.vue?vue&type=script&setup=true&lang=ts"

import "./KeyCap.vue?vue&type=style&index=0&id=a2c2c2c4&scoped=true&lang=css"
import "./KeyCap.vue?vue&type=style&index=1&id=a2c2c2c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2c2c2c4"]])

export default __exports__